import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAppointmentsState } from "../store/appointments/selectors";
import { getAppointments } from "../store/appointments/thunks";
import dayjs from "../utils/dayjs";

export const useAppointments = (month_year) => {
  const dispatch = useDispatch();
  const { loading, appointments } = useSelector(selectAppointmentsState);

  useEffect(() => {
    if (month_year && !appointments[month_year]) {
      dispatch(getAppointments({ month_year }));
    }
  }, [month_year, dispatch, appointments]);

  const { grouped = [], formattedAppointments = [] } = useMemo(() => {
    return (appointments[month_year] || [])?.reduce(
      (acc, appt) => {
        const start = dayjs.utc(appt.start_time).local();
        const end = dayjs.utc(appt.end_time).local();

        const formatted = {
          ...appt,
          start_time: start.toDate(),
          end_time: end.toDate(),
        };

        const key = start.format("YYYY-MM-DD");

        if (!acc.grouped[key]) {
          acc.grouped[key] = [];
        }

        acc.grouped[key].push(appt);
        acc.formattedAppointments.push(formatted);
        return acc;
      },
      { grouped: {}, formattedAppointments: [] },
    );
  }, [appointments, month_year]);

  return {
    loading,
    appointments: appointments[month_year] || [],
    grouped,
    formattedAppointments,
  };
};
